'use strict';

var novicell = novicell || {};

novicell.embedMedia = novicell.embedMedia || new function () {
    var playButtons = document.querySelectorAll('.js-video-overlay-trigger');
    this.init = function() {
        for (var index = 0; index < playButtons.length; index++) {
            var button = playButtons[index];
            button.addEventListener("click", function(e){
                e.preventDefault();
                var currentButton = e.currentTarget;
                var videoId = currentButton.dataset.videoId;
                var videoType = currentButton.dataset.videoType;
                setVideoContent(currentButton, videoId, videoType);
            });
        }
    };
    
    function setVideoContent (button, videoId, videoType) {
        var parent = findAncestor(button, 'embed-media');
        var iframeContainer = parent.querySelector('.embed-media__iframe-container');
        createIframe(videoId, videoType, iframeContainer, parent);
    }

    function createIframe (videoId, videoType, iframeContainer, parent) {
        if (videoId !== null) {
            var src = '';
            if(videoType == 'vimeo') {
                src = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1';
            }
            else if(videoType == 'youtube') {
                src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
            }
            else {
                return;
            }

            var iframe = document.createElement('iframe');
            iframe.setAttribute('src', src);
            iframe.setAttribute('frameborder', 0);
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('allow', 'autoplay');
            iframe.setAttribute('width', '100%');
            iframe.setAttribute('height', '100%');

            iframeContainer.innerHTML = iframe.outerHTML;

            parent.classList.add('embed-media--active');

        } else {
            console.warn('novicell.overlay: video-id is empty. Please provide a video-id for use in video embed code (we support only Vimeo and YouTube).');
            return;
        }
    }
    function findAncestor (el, cls) {
        while ((el = el.parentElement) && !el.classList.contains(cls));
        return el;
    }
}();